import { useLocation } from 'react-router';
import { TrackingDetails } from './types';

/**
 * We need to send exactly what's sent in prod now so we don't mess up existing dashboards
 * For now details, summary, will suffice, we do not track enterprise page
 * Do not change the object mapping without approval
 */
const PAGE_NAME_MAP: Record<string, string> = Object.freeze({
  pricing: 'pricing summary canonical',
  'pricing-teams': 'pricing summary teams',
  'pricing-individual': 'pricing summary individual',
  'pricing-details': 'pricing details canonical',
  'pricing-teams-details': 'pricing details teams',
  'pricing-individual-details': 'pricing details individual',
  'pricing-educational': 'pricing educational',
});

/**
 * Similar to above, a map of generated page names to the ut_source
 * parameter that'll be attached to outgoing links
 */
const UT_SOURCE_MAP: Record<string, string> = Object.freeze({
  pricing: 'pricing-teams-summary',
  'pricing-teams': 'pricing-teams-summary',
  'pricing-details': 'pricing-teams-details',
  'pricing-individual': 'pricing-indv-summary',
  'pricing-teams-details': 'pricing-teams-details',
  'pricing-individual-details': 'pricing-indv-details',
  'pricing-educational': 'pricing-indv-details',
  'pricing-enterprise': 'pricing-teams-summary', // for now we are replicating legacy billweb
  'pricing-enterprise-details': 'pricing-teams-summary',
});

/**
 * This hook returns the tracking info we either need for @sm/metrics or amplitude.
 * This hook can be extended to support all required tracking information in the near future
 * If display name is not provided we fallback to the route
 * @returns TrackingDetails
 */
export default function useTrackingDetails(): TrackingDetails {
  const { pathname, search } = useLocation();
  const utSource = new URLSearchParams(search).get('ut_source');
  // strips and replaces beginning and ending forward slash in the pathname
  const pageName = pathname
    ?.replace(/\//g, '-')
    .replace(/^\W+|\W+$/gm, '')
    .trim();

  return {
    utSource,
    pageName: PAGE_NAME_MAP[pageName],
    pageUtSource: UT_SOURCE_MAP[pageName],
  };
}
